interface Colors {
    primary: string;
    primary100: string;
    primary400: string;
    primary900: string;
    additionalColor?: string;
    additionalColor2?: string;
}
export const defaultColors = {
    standard: {
        secondary: "#606366",
        secondaryLight: "#E3E4E6",
        onPrimary: "#ffffff",
        onSecondary: "#000000",
        background: "#f0f1f2",
        line: "#E3E4E6",
        additionalColor: "#606366",
        additionalColor2: "#00254d"
    }
};
export interface AllColors {
    ww: Colors;
    "1": Colors;
    "2": Colors;
    "3": Colors;
    "4": Colors;
    "5": Colors;
    "6": Colors;
}

export const allColors: AllColors = {
    ww: {
        primary: "#004997",
        primary100: "#B3CCFF",
        primary400: "#91c0f2",
        primary900: "#00254d",
        ...defaultColors.standard
    },
    "1": {
        primary: "#1F7080",
        primary100: "#B6D3D9",
        primary400: "#2EAAC2",
        primary900: "#12454F",
        ...defaultColors.standard
    },
    "2": {
        primary: "#61801F",
        primary100: "#CED9B6",
        primary400: "#719524",
        primary900: "#4F671A",
        ...defaultColors.standard
    },
    "3": {
        primary: "#801A1A",
        primary100: "#D9ADAD",
        primary400: "#B12223",
        primary900: "#601213",
        ...defaultColors.standard
    },
    "4": {
        primary: "#C21D2E",
        primary100: "#FFBFC6",
        primary400: "#D92E40",
        primary900: "#A91827",
        ...defaultColors.standard
    },
    "5": {
        primary: "#E68600",
        primary100: "#FFD599",
        primary400: "#FB9200",
        primary900: "#C97500",
        ...defaultColors.standard
    },
    "6": {
        primary: "#004997",
        primary100: "#F0F1F2",
        primary400: "#E3E4E6",
        primary900: "#606366",
        ...defaultColors.standard
    }
};
